import { Reveal, Eyebrow } from "./Reveal";
import { experience } from "../../data/resume";

export const Experience = () => {
  return (
    <section
      id="experience"
      data-testid="experience-section"
      className="border-t border-hair bg-surface"
    >
      <div className="mx-auto max-w-[1400px] px-6 sm:px-12 lg:px-20 py-24 lg:py-36">
        <Reveal>
          <div className="flex items-end justify-between gap-6 mb-16">
            <div>
              <Eyebrow>(Experience)</Eyebrow>
              <h2 className="mt-6 font-serif font-normal text-4xl sm:text-5xl lg:text-6xl text-ink">
                Where I've worked
              </h2>
            </div>
            <span className="hidden sm:block font-mono text-xs text-inkmuted">
              2019 — 2026
            </span>
          </div>
        </Reveal>

        <div className="flex flex-col">
          {experience.map((job, i) => (
            <Reveal key={i} delay={0.05 * i}>
              <article
                data-testid={`experience-role-${i}`}
                className="group grid grid-cols-1 lg:grid-cols-12 gap-4 lg:gap-8 border-t border-hair py-10 transition-colors duration-500 hover:bg-paper -mx-4 px-4 lg:-mx-6 lg:px-6"
              >
                <div className="lg:col-span-3">
                  <span className="font-mono text-xs uppercase tracking-[0.18em] text-inkmuted">
                    {job.period}
                  </span>
                  <p className="mt-2 font-sans text-sm text-ink">{job.company}</p>
                </div>

                <div className="lg:col-span-9">
                  <h3 className="font-serif text-2xl sm:text-3xl text-ink transition-colors duration-300 group-hover:text-rust">
                    {job.role}
                  </h3>
                  <ul className="mt-5 space-y-3">
                    {job.points.map((p, j) => (
                      <li
                        key={j}
                        className="flex gap-3 font-sans text-sm sm:text-base leading-relaxed text-inksoft"
                      >
                        <span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-rust" />
                        <span>{p}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            </Reveal>
          ))}
          <div className="border-t border-hair" />
        </div>
      </div>
    </section>
  );
};
